import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timePipe'
})
export class TimePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value.closed) {
      return 'Closed';
    }

    if (value.open24Hours) {
      return 'Open 24hrs';
    }

    if ( value.openTime != null && value.closeTime != null) {
      return  `${this.formatMinutestoHours(value.openTime)} - ${this.formatMinutestoHours(value.closeTime)}`;
    }

  }

  formatMinutestoHours(min: number): string {
    let count = 0;
    const hours = (min / 60);
    let rhours = Math.floor(hours);
    let amPm = rhours > 11 ? 'pm' : 'am';
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);
    while (rhours > 12) {
      rhours = rhours - 12;
      count++;
    }
    if (rhours === 0 && count >= 1) {
      rhours = 12;
    }
    if (min === 1440) {
      amPm = 'am';
    }
    return `${rhours.toString().padStart(2, '0')}:${rminutes.toString().padStart(2, '0')}${amPm}`;
  }

}
